<div class="deal-activity-wrapper deal-activity-date">
    <div class="leading-tight">
        {{timePast}}
    </div>
    <div class="leading-none mt-1">
        {{date}}
    </div>
</div>
